import { PartialDatePrecision } from 'common/api/PartialDateType';
import format from 'common/tools/date/format';

export class PartialDate {
  readonly date: Date;
  readonly precision: PartialDatePrecision | string;

  constructor(date: string | Date, precision: PartialDatePrecision | string) {
    this.precision = precision;
    this.date = this.parseToDate(date, precision);
  }

  private parseToDate(
    date: string | Date,
    precision: PartialDatePrecision | string
  ): Date {
    if (date instanceof Date) {
      return date;
    }

    const [year, month, day] = this.parseDateParts(date);
    switch (precision) {
      case PartialDatePrecision.MONTH:
        return new Date(year, month, 0); // Last day of the month
      case PartialDatePrecision.YEAR:
        return new Date(year, 11, 31); // December 31 of the year
      default:
        return new Date(year, month - 1, day);
    }
  }

  private parseDateParts(date: string): [number, number, number] {
    if (/^\d{8}$/.test(date)) {
      // Format YYYYMMDD
      const year = parseInt(date.slice(0, 4), 10);
      const month = parseInt(date.slice(4, 6), 10);
      const day = parseInt(date.slice(6, 8), 10);
      return [year, month, day];
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date.split('-').map(Number) as [number, number, number];
    }
    const parsedDate = new Date(date);
    return [
      parsedDate.getFullYear(),
      parsedDate.getMonth() + 1,
      parsedDate.getDate()
    ];
  }

  format() {
    switch (this.precision) {
      case PartialDatePrecision.DAY:
        return format(this.date, {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      case PartialDatePrecision.MONTH:
        return format(this.date, { month: '2-digit', year: 'numeric' });
      case PartialDatePrecision.YEAR:
        return format(this.date, { year: 'numeric' });
    }
  }
}
